module.exports = {
    faqPhotography: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [{
            "@type": "Question",
            "name": "Tι είδους φωτογραφικές υπηρεσίες παρέχετε;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": `Παρέχουμε όλων των ειδών τις φωτογραφικές υπηρεσίες:
                        προϊοντικές φωτογραφίσεις για eshop,
                        Φωτογραφίσεις μόδας,
                        Φωτογραφικές υπηρεσίες για events,
                        Επαγγελματική φωτογράφιση χώρου,
                        Επεξεργασία φωτογραφιών ,
                        Και πολλές ακόμη που θα χαρούμε να σας πούμε από κοντά.`
            }
        }, {
            "@type": "Question",
            "name": "Διαθέτετε φωτογραφικό studio;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Ναι, στα κεντρικά μας γραφεία στο Μαρούσι διαθέτουμε και φωτογραφικό studio. Θα χαρούμε να σας φιλοξενήσουμε για την επόμενη σας φωτογράφιση."
            }
        }, {
            "@type": "Question",
            "name": "Eκτός από τη φωτογραφική λήψη, κάνετε και επεξεργασία φωτογραφίας;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Παρέχουμε όλες τις φωτογραφικές υπηρεσίες και ναι φυσικά και την κατάλληλη επεξεργασία."
            }
        }, {
            "@type": "Question",
            "name": "Είναι έμπειρη η ομάδα σας;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Όχι μόνο είναι έμπειρη αλλά είναι και αυτή που δημιούργησε το 2009 το μεγαλύτερο φωτογραφικό portal στην Ελλάδα, το redcarpet.gr . Δεκάδες συνεργάτες φωτογράφοι με εκατομμύρια “κλικς” εμπειρία σε κάθε φωτογραφική υπηρεσία."
            }
        }, {
            "@type": "Question",
            "name": "Μπορούμε να δούμε δείγμα δουλειάς σας;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Φυσικά. Καλέστε μας, αναλύστε μας το είδος της φωτογραφικής υπηρεσίας που επιθυμείτε και εμείς θα σας αποστείλουμε το κατάλληλο υλικό από το portfolio μας."
            }
        }, {
            "@type": "Question",
            "name": "Αναλαμβάνετε και όλη τη παραγωγή μίας φωτογράφισης;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Ναι ότι χρειάζεται για να πραγματοποιηθεί μία άρτια φωτογράφιση το παρέχουμε. Ρεπεράζ για την εύρεση του κατάλληλου χώρου, διεύθυνση παραγωγής, make up, hair, styling, μοντέλο και φυσικά κάθε είδους επιθυμητός εξοπλισμός."
            }
        }]
    },
    faqVideography: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [{
            "@type": "Question",
            "name": "How much does a video cost?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "There is no specific answer to this question. The value of a video has to do with a lot of factors, such as its script, the choice of actors and contributors, its use (TV or Web) and especially the goal it wants to achieve (Awareness, sales, tutorial, corporate, funding, etc). However, with one visit to our offices, we know that we will answer all of your questions."
            }
        }, {
            "@type": "Question",
            "name": "Can I get a sample of your work?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Of course you can as we are very proud of the collaboration we have. On our website in the category \"Video & Photography\" you will find the latest showreel which is a selected sample of several different works we have implemented. Corporate videos, TV, video clips, animations, events, etc."
            }
        }, {
            "@type": "Question",
            "name": "What is Live Streaming?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Live streaming is the real time streaming of video over the internet by using any device that can record video, whether it is a professional video camera or a simple camera, web cam, tablet or smartphone. Thanks to the rapid development of the relevant technology and the expansion of the live streaming services market, anyone can now retransmit live video from where it is located, with competitive quality and without any unwanted complications. All it has to do is choose the right live streaming service, the equipment it will use to \"capture\" its video, as well as the content of its transmission, which it will share with its potential audience in order to fix it on its \"channel\". For others it is their talent, for others it is an event worth spreading and for others it is an event that \"happens now\" and \"seeks\" eyewitnesses."
            }
        }, {
            "@type": "Question",
            "name": "Why is Live Streaming so important to every brand?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "If, however, live streaming changes the role of the user-viewer in the process of creating and spreading video content on the Internet, one can easily imagine how useful such a tool can be for a professional or a company who wants to enrich its narrative. to expand its recognition and to charm its audience. Original and quality video that connects the viewer with the \"moment\" and possibility of \"participation\" through his favorite social media accounts can help him become actively involved in the campaigns that concern him. With content marketing remaining an ever-changing field of action for marketing strategists and content providers alike, the ability to communicate the \"superiority\" of a brand with the main weapon being the power and prestige of a live video is a major challenge, especially for content creators and content creators alike. It is also an opportunity to interact directly and effectively with the younger, technologically advanced generation, who have learned to be in constant visual contact with what they are interested in, as well as to respond in a variety of ways to the stimuli they receive through the platform they use. Indicatively, according to research, Generation Z members (young people born after the mid-1990s) enter YouTube and social media daily, prefer live streaming to other TV services, and enjoy multitasking while they watch videos in the vast majority, in percentages that reach 90%. Of course, in order to approach the public in a way that will lead to measurable responses and substantial conversions to tangible goals, it's not enough to use one of the available live streaming services and simply organize a live broadcast of the show to be a part of the public experience. An event designed for everyone to see (or even an audience able to make a successful live campaign) must be well organized and have adequate coverage of a proper TV campaign, high quality video and sound and well-designed flow, in order to keep the interest and not to motivate the audience to \"change channels\”.Think Plus, having entered the market of live streaming services dynamically, offers a flexible transmission system with multiple coverage through Full HD cameras that adapts to any space and successfully meets the highest requirements, in direction, quality, speed and connectivity. Even in places with limited or no internet connection, Think Plus live streaming services use 4G technology to deliver 100% of their capabilities whenever and wherever necessary."
            }
        }, {
            "@type": "Question",
            "name": "Do you undertake live streaming coverage?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, all kinds of streaming in every region of Greece. Huge brands and organizations have already trusted us either to present their new product or to cover an extremely important conference."
            }
        }, {
            "@type": "Question",
            "name": "How to take advantage of videos via Instagram?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": `Creating content for IGTV doesn't have to be fancy - as effective. Let's look at some ideas that can be applied in these early stages of IGTV and level up your business.
                1)Q & A’s
                Interviews and Q&A’s with industry leaders or with people in your organization or business can, if done right, offer great value to your audience. This is also the simplest and easiest way to get started with IGTV and explore its potential, without time constraints or the risk of bad connections and live video interruptions.
                2)Intros
                This is the most popular tactic on YouTube and is even more valuable on IGTV, especially thanks to its uniqueness of playing videos directly with what the user enters. A good introductory video can help your visitors understand who you are, what you do and what exactly they can expect from you on your IGTV channel or on your Instagram profile.
                3)Tutorials
                Tutorials and webinars are the best way to educate your audience about how to use a product or service. Creating an online library of useful information can be beneficial for branding but also for building your credibility on a particular topic.
                4)Content republishing
                Another great idea you can use for your brand or business is to republish other videos and place them on your IGTV channel. This process may require some editing, especially if your video was originally created for horizontal viewing, but it's also the best way to extend the life of videos for more than 24 hours on Stories and Live.
                At Think Plus we closely monitor developments on social media.
                IGTV is a rather new tool that, with proper use, can pay off in the long run and bring your business one step ahead of the competition. But as it is the latest addition to an ever-changing landscape in which there are so many different components to success, you need the guidance of an expert in the field to help you grow and make a substantial profit.
                Think Plus is closely following all the new developments in the field of social media from the moment of their creation and we know exactly how to adapt to each case, with equally successful results. At the same time, we have extensive and long-term experience in video production for marketing purposes and we are ready to apply our know-how to the vertical form of IGTV. Your cooperation with us will highlight your company and this can be guaranteed by the award-winning success stories we have gone through so far! Perhaps, you can be the next success story?`
            }
        }, {
            "@type": "Question",
            "name": "Do you undertake all kinds of videos?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, whatever kind of video you want and for any use and purpose, our experienced production team will provide you with the solution. So whether it is corporate videos, TV, video clips, animation, events, promotional or crowdfunding, plan a visit to our offices and we will guide you accordingly."
            }
        }, {
            "@type": "Question",
            "name": "Do you have a studio?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, we have a studio properly equipped for photography, video with green screen capability and recording studio."
            }
        }, {
            "@type": "Question",
            "name": "What is the process for producing a video?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "We have a very specialized staff in the area of video production with many years of experience. In the pre-production stage, we design the style and structure of the video. Based on your aesthetics and goals, our creative department drafts up the storyboard (storytelling, animation or natural persons, casting), and we present it to you for approval. This is followed by the production stage where the shooting or the composition of images take place (in case no shooting is required). In the post production stage, our experienced editors make the final touches (color corrections, add effects and graphics, sound mixing) and transfer the corporate video to the appropriate media for its distribution."
            }
        }, {
            "@type": "Question",
            "name": "Do you also undertake voice over / speakage?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Of course, we also have a large sample of selections in Greek speakers but also in many other languages."
            }
        }, {
            "@type": "Question",
            "name": "What kind of equipment do you use?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Think Plus has state-of-the-art equipment capable of meeting every need, whatever it might be."
            }
        }, {
            "@type": "Question",
            "name": "Do you also promote Video?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "We \"mix\" the viral trend with marketing strategies, and create effective viral video campaigns with strong interaction. We approach the target group and share the video on websites and social media that bring the maximum possible engagement! Choose Think Plus to promote your video and become the new viral star of your audience!"
            }
        }, {
            "@type": "Question",
            "name": "Why choose Think Plus to produce my own video?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "We create corporate videos that fully correspond to your company's image and values. But we don't stop there. We provide a comprehensive Video Marketing strategy that will ensure your success. We are by your side, from the moment you create a video to the reports that will accompany the end of the marketing campaign. We have renowned and experienced partners and of course the innovative look that characterizes our company and every service we offer separately is a testament to our commitment to our business."
            }
        }]
    },
    faqShopify: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [{
            "@type": "Question",
            "name": "Is Shopify available in every country?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, Shopify is now available and very popular in nearly every country in the world, constantly gaining ground and popularity."
            }
        }, {
            "@type": "Question",
            "name": "Do I need to be a web developer to create my own Shopify?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "No, it is not necessary, as Shopify's own management tool gives you the ability to create your own online store easily and without much technical knowledge. Of course, if you really want to take full advantage of Shopify's capabilities and meet your specialized needs, we recommend that you trust the experts of Think Plus."
            }
        }, {
            "@type": "Question",
            "name": "Is Shopify after all, an affordable or expensive solution?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "At Think Plus, we don’t like to distinguish between inexpensive and expensive solutions, rather than correct or incorrect ones. Shopify is structured based on the philosophy, \"scale up & pay as you go\", as a result of which it provides excellent tools and automation to the user at a cost significantly lower than any other management system. In summary, Shopify is the right solution for anyone who wants to succeed in the world of e-commerce and Think Plus can point out the right way."
            }
        }, {
            "@type": "Question",
            "name": "What are the main advantages of Shopify over other management systems?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": `Some of the most important benefits of Shopify:
                        
                        1. Customer History
                        The field of your customers in the eshop itself, helps you to learn more about your customers, as well as their buying habits. You can also use this to locate both their contact information and their order history at a glance.
                        
                        2. Abandoned Cart Recovery
                        In case of an unexpected exit of the customer from your eshop without completing the transaction and even if they had already placed products in their shopping cart, shopify lets you automatically send them a reminding email. It is estimated that about 1 in 3 orders are abandoned during the shopping completion process. This feature helps you attract your customers and increase your sales.
                        
                        3. Multi-Language Checkout
                        With the ability to select from more than 50 languages ​​on the payment page and throughout the navigation, as well as the choice of a variety of local currencies, Shopify gives you the ability to surpass your national borders and to have a real international store. Your concern: \"good product, great pricing, excellent performance marketing\".

                        4. Backend Mobile Application
                        Shopify’s mobile app allows you to track all the important updates for your store and run it fully from your iOS or Android device. Use this powerful backend tool to check your customers statistics, products, orders, details and maximize your turnover.`
            }
        }, {
            "@type": "Question",
            "name": "What does Think Plus include in the basic Shopify eshop package?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": `-Categorization of products for unlimited levels of categories and subcategories
                        -Detailed presentation of each product or service with an unlimited number of photos, category, subcategory, code, supplier company, description and price. Any other product specifications may be included in the description.
                        -Back Office System with Mobile Application of the online store for order management and also members or customers
                        -Complete database management of products with easy-to-use environment for additions, subtractions and any kind of modifications
                        -Build an e-shop with all modern navigation filters (tags)
                        -Member-customer registration process (Sign In), Search (full text) and advanced search & Shopping Basket
                        -"Collections" of presentation of selected products on the main page and on the homepage of each product category
                        -Automatic email notification to the administrator for each and every order
                        -Related products functionality
                        -Customer password recovery service email in case of loss 
                        -Abandoned Cart Recovery email nofication service of selected products
                        -Coupon system with shareable link & gift cards
                        -Ability to register the visitor for newsletters & email campaigns
                        -Financial statistics about your shop using reports
                        -Corporate presentation with a complete analysis of the company's history, activities, financial figures
                        -Keywords & meta description option for category and product pages
                        -Keywords & meta description option for content pages
                        -Ability to configure Sitemap
                        -Adjustable shipping and tax costs for all countries
                        -Sales Channels on Facebook & Instagram with Tags & Product Catalog
                        -Import products through CSV files
                        -The customer can directly modify the selected products in the cart
                        -The registered customer can modify the details of his account at any time                
                        -The registered customer can see the history of his orders.                
                        -Complete list of offline payment methods: Bank deposit, Money transfer via e-banking, Cash on delivery, etc.                
                        -Full online payment support: Credit cards (Viva Payments), Paypal Express                
                        -Full HTTPS / SSL support with free certificate                
                        -Password protection in access management
                        -Automatic fraud analysis system in IP Location transactions                
                        -24/7 Support for technical issues related to Shopify by phone, email and live chat
                        -Unlimited bandwidth and online storage hosting`
            }
        }, {
            "@type": "Question",
            "name": "To put it simply, why should I choose Shopify for my eshop?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": `There are too many reasons for us, technical and others. But if we are to focus on non-technical reasons, these would be the following:

                -It is the fastest growing ecommerce software in the world,
                -There is a huge private company backing it up, with thousands of employees who develop the platform daily, the benefits of which are harvested by its end users; unlike any other open source management tool. 
                -Shopify's philosophy is sales and marketing oriented, and is self-structured to maximize sales,
                -It is very simple to use unlike other management platforms,
                -The first connection that facebook & instagram established with the world of  ecommerce it was Shopify; and that says a lot…
                -It has been recorded that there are Shopify shops that make billions in turnover (Kylie Jenner),
                -It provides the best server in the world and strong levels of security and speed,
                -and many more reasons we would be happy to share with you in person, at Think Plus.`
            }
        },{
            "@type": "Question",
            "name": "Can my shopify be shared with skroutz?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Of course it can. One of the most important advantages of Shopify is the app store it comes with; just like your smartphone. You can find hundreds of applications, free and not, which you can easily install on your shopify and increase your sales. One of them is the application for Skroutz which is <a href=\"https://apps.shopify.com/export-product-skroutz-xml-feed\" target=\"_blank\">completely free</a> and has been developed by Think Plus."
            }
        }, {
            "@type": "Question",
            "name": "Can my shopify be shared with BestPrice?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Of course it can. One of the most important advantages of Shopify is the app store it comes with; just like your smartphone. You can find hundreds of applications, free and not, which you can easily install on your shopify and increase your sales. One of them is the application for BestPrice which is <a href=\"https://apps.shopify.com/export-product-best-price-xml-feed\" target=\"_blank\">completely free</a> and has been developed by Think Plus."
            }
        }, {
            "@type": "Question",
            "name": "Can my shopify be shared with Glami?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Of course it can. One of the most important advantages of Shopify is the app store it comes with; just like your smartphone. You can find hundreds of applications, free and not, which you can easily install on your shopify and increase your sales. One of them is the application for Glami which is completely free and has been also developed by Think Plus."
            }
        }, {
            "@type": "Question",
            "name": "Why choose Think Plus for my Shopify shop?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": `This is, of course, a question we would love to answer in person. But if we had to choose three main reasons, they would be:

                We are the company with the most experienced shopify team in Greece.
                We are the only software company that developed our own <a href=\"https://apps.shopify.com/partners/think-plus1\" target=\"_blank\">applications for Shopify’s app store</a> and received many positive reviews.
                We are your strategic partner in the world of e-commerce as in addition to your shopify, we can provide you with all the necessary services to succeed in this highly competitive space.`
            }
        }]
    },
    faqWordpress: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [{
            "@type": "Question",
            "name": "Τι είναι το WordPress;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Το WordPress είναι ένα σύστημα διαχείρισης περιεχομένου ( CMS content management system ) που μπορεί να χρησιμοποιηθεί για τη κατασκευή οποιασδήποτε ιστοσελίδας. Είναι γεγονός ότι αρχικά κατασκευάστηκε για την υλοποίηση blogspots. Παρόλα αυτά με τη πάροδο των χρόνων, εξελίχθηκε στο πλέον σύγχρονο, ασφαλές και δημοφιλές πρόγραμμα κατασκευής ιστοσελίδων παγκοσμίως. Είναι σημαντικό να γνωρίζετε ότι είναι λογισμικό ανοιχτού κώδικα (open source) και εξαιρετικά φιλικό τόσο με τις μηχανές αναζήτησης, όσο και τα κοινωνικά δίκτυα. Τέλος δεν χρειάζεται κανείς να γνωρίζει κάτι παραπάνω, πέραν του ότι το wordpress αποτελεί τη βάση για το 31% των websites παγκοσμίως. Στη Think Plus με την εμπειρία των 1.000 websites στα τελευταία δέκα έτη, μπορούμε να σας καθοδηγήσουμε σωστά για το πως θα αποκτήσετε μία ιστοσελίδα που αναδεικνύει την επιχείρησή σας και αποτελεί ταυτόχρονα ένα εξαιρετικό εργαλείο marketing."
            }
        }, {
            "@type": "Question",
            "name": "Το WordPress υποστηρίζει τα ελληνικά;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Το wordpress είναι ο βασιλιάς στο βασίλειο των ιστοσελίδων. Εξελίσσεται καθημερινά και αναπτύσσεται με ταχύτητα σε κάθε κατεύθυνση. Φυσικά και υποστηρίζει Ελληνικά με το encoding UTF-8. Δεν ξέρουμε αν είναι η πλέον βέλτιστη λύση για κάθε ανάγκη αλλά σίγουρα είναι το διαχειριστικό που καλύπτει τις περισσότερες παγκοσμίως."
            }
        }, {
            "@type": "Question",
            "name": "Το WordPress είναι εύκολο στην χρήση του;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Το wordpress είναι πανεύκολο στη χρήση του. Κάθε χρήστης, όσο εξοικειωμένος και αν είναι με υπολογιστές και απλά προγράμματα, μπορεί εύκολα και γρήγορα να διαχειριστεί πλήρως το περιεχόμενο της ιστοσελίδας του. Να ανεβάζει φωτογραφίες και βίντεο, να τροποποιεί το λεκτικό των εσωτερικών σελίδων και πολλά πολλά άλλα. Στη Think Plus, με τη παράδοση κάθε ιστοσελίδας, εκπαιδεύουμε πλήρως τοn πελάτη μας πως θα δύναται να διαχειρίζεται την ιστοσελίδα του, δημιουργώντας σχέσεις δίχως εξαρτήσεις."
            }
        }, {
            "@type": "Question",
            "name": "Το WordPress έχει συχνές ενημερώσεις;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Το Wordpress έχει συχνές ενημερώσεις (updates) είτε στη κεντρική πλατφόρμα (core) είτε στα plugins. Στόχος φυσικά των updates είναι να βελτιστοποιήσουν τον κώδικα, κάνοντας τον πιο σύγχρονο, ασφαλή και ταχύ. Φυσικά κάθε update καλύπτει μία συγκεκριμένη ανάγκη και προτού το κάνετε θα πρέπει να είστε βέβαιοι ότι έχετε πάρει backup, καθώς μπορεί να προκύψουν θέματα ασυμβατότητας μεταξύ του κυρίου wordpress και των plugins, που δεν θα είναι εύκολο να επιλυθούν."
            }
        }, {
            "@type": "Question",
            "name": "Τα WordPress που κατασκευάζετε έχουν custom themes;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Στη Think Plus έχουμε ως βασικό κανόνα να αναλύουμε και τελικά να εξυπηρετούμε κάθε ανάγκη των πελατών μας. Αν μέσα από τη διεξοδική ανάλυση προκύπτει ότι απαιτείται η υλοποίηση της ιστοσελίδας με Custom theme, τότε αυτό προσφέρουμε στο πελάτη μας. Η εταιρεία μας εξάλλου φημίζεται για το εξαιρετικά ικανό τεχνικό της τμήμα που μετράει αρκετές διακρίσεις σε Ελλάδα και εξωτερικό. Παρόλα αυτά βασικός μας κανόνας είναι να μην κάνουμε “oversell” δηλαδή ποτέ δεν προσπαθήσουμε να σας πείσουμε στο βωμό μιας καλύτερης αμοιβής, για κάτι που δεν πιστεύουμε ότι σας χρειάζεται."
            }
        }, {
            "@type": "Question",
            "name": "Προσφέρετε φιλοξενία με τα WordPress site σας;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Φυσικά σε υπερσύγχρονους servers με εξαιρετικά ανταγωνιστικές τιμές και εγγύηση ταχύτητας και καλής απόδοσης."
            }
        }, {
            "@type": "Question",
            "name": "Τα WordPress που κατασκευάζετε εμπεριέχουν plugins;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Ναι, όταν αυτό απαιτείται για να ικανοποιηθεί μία πολύ συγκεκριμένη ανάγκη. Φυσικά επιλέγουμε τα plugins με πολύ συγκεκριμένα και αυστηρά κριτήρια, πάντα με πολλές και θετικές αξιολογήσεις, για να είμαστε βέβαιοι ότι δεν θα δημιουργηθεί κάποιο πρόβλημα στην ιστοσελίδα. Τα plugins μπορούν να είναι τόσο ένα χρήσιμο όσο και επικίνδυνο εργαλείο. Γι αυτό χρειάζεστε τους ειδικούς της ομάδας μας."
            }
        }, {
            "@type": "Question",
            "name": "Ποιο είναι το επίπεδο ασφαλείας στο WordPress;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Είναι εξαιρετικά μεγαλύτερο από κάθε άλλο διαχειριστικό παγκοσμίως. Παρόλα αυτά οι έμπειρη ομάδα προγραμματιστών μας θα σας προτείνει και άλλους τρόπους για να προστατευθείτε με ασφάλεια από κακόβουλους εχθρούς."
            }
        }, {
            "@type": "Question",
            "name": "Θα μπορώ να έχω blog με το WordPress;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Φυσικά θα μπορείτε και επιβάλλεται. Με τη συχνή ανανέωση του blog βοηθάτε απίστευτα την ιστοσελίδα σας να κατακτήσει τη κορυφή των αποτελεσμάτων των μηχανών αναζήτησης. Μάλιστα στην ομάδα μας υπάρχουν εξαιρετικοί κειμενογράφοι που μπορούν να σας παρέχουν την υπηρεσία της επαγγελματικής αρθρογραφίας."
            }
        }, {
            "@type": "Question",
            "name": "Μπορώ να ανεβάζω δικές μου φωτογραφίες και βίντεο στο WordPress;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Πανεύκολα. Βέβαια πριν το κάνετε σιγουρευθείτε ότι κατέχετε τα δικαιώματα των φωτογραφιών και βίντεο που ανεβάζετε."
            }
        }, {
            "@type": "Question",
            "name": "Είναι εύκολο να δημιουργήσω καινούργιες σελίδες με το WordPress?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Πανεύκολο, όπως και συνολικά όλη η διαχείριση του wordpress. Mε την εκπαίδευση που σας κάνει η εξειδικευμένη ομάδα μας, η διαχείριση του wordpress σας θα είναι παιχνιδάκι."
            }
        }, {
            "@type": "Question",
            "name": "Πόσες σελίδες έχουν τα WordPress που κατασκευάζετε?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Πάρα πολύ καθώς η ταχύτητα είναι εξαιρετικά σημαντικός παράγοντας για την επιτυχία μίας ιστοσελίδας. Ζούμε εξάλλου στην εποχή της ταχύτητας. Απαγορεύεται λοιπόν η ιστοσελίδα σας να είναι αργή."
            }
        }, {
            "@type": "Question",
            "name": "Το WordPress υποστηρίζει E commerce?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Υποστηρίζει αλλά μόνο μέσω plugin. Δεν το συνιστούμε καθώς είναι ένα διαχειριστικό που δεν έχει υλοποιηθεί με βασική κατευθυντήρια και προσλαμβάνουσα το ηλεκτρονικό εμπόριο. Επομένως οι ελλείψεις είναι πολλές. Στη Think Plus προτείνουμε Shopify."
            }
        }, {
            "@type": "Question",
            "name": "Τα WordPress που κατασκευάζετε έχουν την δυνατότητα SSL?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Δεν έχουν απλώς τη δυνατότητα. Έχουν όλα SSL."
            }
        }, {
            "@type": "Question",
            "name": "Προσφέρετε Τεχνική υποστήριξη για WordPress?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Φυσικά με την αρχική μας κιόλας οικονομική προσφορά για την υλοποίηση της δικιάς σας ιστοσελίδας με wordpress, λαμβάνετε τη πρότασή μας είτε για πάγιο μηνιαίο support είτε για κατά περίπτωση (ad hoc)"
            }
        }, {
            "@type": "Question",
            "name": "Προσφέρετε Backup για WordPress?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Φυσικά και είναι άκρως απαραίτητο ώστε να διασφαλίζεται ότι εξαλείφεται ο κίνδυνος να χαθούν δεδομένα."
            }
        }]
    },
    faqDigitalMarketing: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [{
            "@type": "Question",
            "name": "Τι είναι το digital marketing;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "To digital marketing συμπεριλαμβάνει όλες τις προσπάθειες μάρκετινγκ που χρησιμοποιούν μια ηλεκτρονική συσκευή ή το διαδίκτυο. Οι επιχειρήσεις εκμεταλλεύονται ψηφιακά κανάλια όπως μηχανές αναζήτησης, social media, email και άλλους τρόπους για για να προσεγγίσουν το κοινό τους και πιθανούς μελλοντικούς πελάτες. Συνεχώς προστίθενται νέα εργαλεία στον κόσμο του digital marketing."
            }
        }, {
            "@type": "Question",
            "name": "Τι υπηρεσίες προσφέρετε;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Προσφέρουμε ένα πλήθος online & offline marketing υπηρεσιών για κάθε επιχείρηση. Υπηρεσίες digital marketing συμπεριλαμβάνουν content marketing, SEO, PPC, email marketing, influencer marketing, mobile marketing & video marketing."
            }
        }, {
            "@type": "Question",
            "name": "Πόσα χρόνια ασχολείστε με το digital marketing;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Η Think Plus ασχολείται με την ψηφιακή επικοινωνία επιχειρήσεων και προώθηση ιστοσελίδων από το 2009. Διαθέτει μεγάλη εμπειρία, διαπιστεύσεις, εθνικές και διεθνείς διακρίσεις."
            }
        }, {
            "@type": "Question",
            "name": "Έχετε τιμολογιακή πολιτική;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Η τιμολογιακή πολιτική διαμορφώνεται ανάλογα με τις ανάγκες του πελάτη και του εκάστοτε project."
            }
        }, {
            "@type": "Question",
            "name": "Έχετε Case studies;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Ναι φυσικά. Θα βρείτε τα case studies μας στον ακόλουθο <a href=\"https://think-plus.gr/our-work/\">σύνδεσμο</a>"
            }
        }, {
            "@type": "Question",
            "name": "Έχετε digital account managers;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Ναι, φυσικά. Κάθε project ή πελάτης έχει τον δικό του Digital Account Manager για άμεση επικοινωνία και εξυπηρέτηση."
            }
        }, {
            "@type": "Question",
            "name": "Έχετε testimonials;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Φυσικά και έχουμε. Μπορείτε να μπείτε στο website μας και να δείτε κάποια από τα testimonials των πελατών μας."
            }
        }, {
            "@type": "Question",
            "name": "Θα με βοηθήσετε με τους στόχους της επιχείρησης μου;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Φυσικά. Κάθε project που αναλαμβάνουμε εμπεριέχει την αναλυτική και ουσιαστική ικανοποίηση των αναγκών κάθε επιχείρησης με ρεαλιστικούς και μετρήσιμους στόχους."
            }
        }, {
            "@type": "Question",
            "name": "Πως διαχειρίζεστε τα Digital Marketing project σας;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Κάθε Digital Marketing project έχει ένα και μοναδικό φάκελο όπου εμπεριέχει όλα τα resources και τα deliverables που πρέπει να παραδοθούν μέχρι το τέλος της χρονικής περιόδου που έχει προσυμφωνηθεί με κάθε πελάτη."
            }
        }, {
            "@type": "Question",
            "name": "Πως θα με ενημερώνετε για την πρόοδο των Digital Marketing ενεργειών της επιχείρησης μου;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Κάθε Digital Marketing project έχει συγκεκριμένους Project Managers και Account Managers που αναλαμβάνουν την επικοινωνία της προόδου και αποτελεσμάτων στους πελάτες ή στους υπεύθυνους επικοινωνίας κάθε project."
            }
        }, {
            "@type": "Question",
            "name": "Κάνετε SEO (Search Engine Optimization);",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Όλα τα website που κατασκευάζουμε (είτε είναι ιστοσελίδες ή e-shops) είναι search engine optimized για τα προϊόντα και τις υπηρεσίες των πελατών, χωρίς επιπλέον κόστος. Φυσικά, προσφέρουμε την συγκεκριμένη υπηρεσία και σε πελάτες που έχουν αυτή την ανάγκη, όταν δεν υπάρχουν οι σωστές υποδομές στα website τους."
            }
        }, {
            "@type": "Question",
            "name": "Σε πόσο καιρό θα δω αποτελέσματα από τις ενέργειες σας;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Κάθε project είναι διαφορετικό οπότε θα ήταν άδικο να προσδιορίσουμε τον ελάχιστο χρόνο επιτυχίας. Ενδεικτικά, στις διαφημιστικές ενέργειες μέσω PPC, τα αποτελέσματα είναι συνήθως άμεσα."
            }
        }, {
            "@type": "Question",
            "name": "Κάνετε επιλογές στα κανάλια επικοινωνίας βάση project;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Ναι επειδή είναι απαραίτητο για την επιτυχία του project. Αυτό πρακτικά σημαίνει ότι δημιουργούμε ένα πλάνο digital marketing με βάση τους στόχους της επιχείρησης."
            }
        }]
    },
    faqGoogleAds: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [{
            "@type": "Question",
            "name": "Τι είναι τα Google Ads (πρώην AdWords);",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Τα Google Ads (πρώην AdWords) είναι η διαφημιστική πλατφόρμα της Google. Επιτρέπει σε διαφημιστές και επιχειρήσεις να διαφημίσουν προιοντα και υπηρεσιες σε ολόκληρο το δίκτυο της Google (πχ Google Search, YouTube κτλ)."
            }
        }, {
            "@type": "Question",
            "name": "Χρειάζομαι Google Ads (πρώην AdWords) για την επιχείρηση μου;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Όλες οι επιχειρήσεις χρειάζονται ενέργειες προώθησης και διαφήμισης. Άλλες σε λιγότερο και άλλες περισσότερο."
            }
        }, {
            "@type": "Question",
            "name": "Είναι δύσκολη η διαχείριση των Google Ads (πρώην AdWords);",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Τα Google Ads (πρώην AdWords) προσφέρουν πολλαπλές εμπειρίες χρήστη ανάλογα με το επίπεδο γνώσεων που έχει. Πχ η εμπειρία χρήστη για τοπικές καμπάνιες είναι συντριπτικά πιο εύκολη σε σχέση με την εμπειρία χρήστη για πρόσβαση σε όλες τις καμπάνιες των Google Ads (πρώην AdWords). Οπότε, εξαρτάται από το επίπεδο γνώσεων του χρήστη."
            }
        }, {
            "@type": "Question",
            "name": "Τι είναι δομή λογαριασμού Google Ads (πρώην AdWords);",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Η δομή λογαριασμού επιτρέπει την καλύτερη διαχείριση και αξιολόγηση των προωθητικών ενεργειών μιας επιχείρησης ή ενός agency. Η πιο απλή δομή λογαριασμού είναι: λογαριασμός > καμπάνια > ομάδα διαφημίσεων > διαφήμιση"
            }
        }, {
            "@type": "Question",
            "name": "Τι είναι KPIs στα Google Ads (πρώην AdWords);",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Τα KPIs στα Google Ads (πρώην AdWords) είναι δείκτες που επιτρέπουν σε διαφημιστές και επιχειρήσεις να παρακολουθούν το επίπεδο επιτυχίας των προωθητικών ενεργειών τους στα Google Ads (πρώην AdWords). Κάθε προωθητική ενέργεια έχει και τους δικούς της δείκτες."
            }
        }, {
            "@type": "Question",
            "name": "Τι είναι οι επεκτάσεις (extensions) στα Google Ads (πρώην AdWords);",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Οι επεκτάσεις εμπλουτίζουν τις διαφημίσεις των Google Ads (πρώην AdWords)  με πρόσθετες πληροφορίες. Στατιστικά αυτές οι πληροφορίες αυξάνουν την αναλογία κλικ προς αριθμό εμφανίσεων και αυτό μεταφράζεται σε αύξηση πωλήσεων."
            }
        }, {
            "@type": "Question",
            "name": "Τι είναι ο δείκτης ποιότητας στα Google Ads (πρώην AdWords);",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Ο δείκτης των Google Ads (πρώην AdWords) είναι μια εκτίμηση του συνόλου της διαφημιστικής ενέργειας. Το σύνολο της διαφημιστικής ενέργειας εμπεριέχει: διαφήμιση, λέξεις-κλειδιά, σελίδες προορισμού (landing pages). Ένας υψηλότερος δείκτης ποιότητας οδηγει σε χαμηλότερα κόστη κλικ και αυξημένες πωλήσεις."
            }
        }, {
            "@type": "Question",
            "name": "Tι είναι το CTR;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Η αναλογία κλικ προς αριθμό εμφανίσεων ή το CTR (click-through-rate) είναι ένας δείκτης που χρησιμοποιείται για τη μέτρηση της επιτυχίας μιας διαδικτυακής διαφημιστικής καμπάνιας. Παρουσιάζεται ως ποσοστό, υπολογιζόμενο με βάση: τον αριθμό των κλικ που λαμβάνει η διαφήμισή σας διαιρούμενα με τον αριθμό των φορών που εμφανίζεται η διαφήμισή σας (αποκαλούμενες εμφανίσεις). Το ποσοστό αναφοράς για το CTR που προσδιορίζει η Google είναι 1-2% (για τη διαφήμιση αναζήτησης)."
            }
        }, {
            "@type": "Question",
            "name": "Τι είναι το CPA;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Το κόστος ανά απόκτηση (Cost per Acquisition) - επίσης αναφέρεται ως CPA (Cost Per Action). Είναι η μέτρηση που χρησιμοποιείται για τον προσδιορισμό του κόστους σας ανά πώληση / ενέργεια από τη διαφήμισή σας. Αυτή είναι μια βασική μέτρηση για τον προσδιορισμό της απόδοσης της επένδυσής σας."
            }
        }, {
            "@type": "Question",
            "name": "Πόσο μου κοστίζει κάθε κλικ;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Αυτό εξαρτάται από τον τομέα της επιχείρηση και τους ανταγωνιστές σας. Με τα Google Ads (πρώην AdWords), μια σειρά από στοχευμένες φράσεις-κλειδιά μπορεί να ερευνηθεί και τελικά να επιλεχθεί από τον χρήστη - υποψήφιο πελάτη. Όταν αυτές οι λέξεις-κλειδιά χρησιμοποιούνται σε μια αναζήτηση από έναν χρήστη, θα ενεργοποιήσουν την εμφάνιση μιας διαφήμισης. Οι προσφορές τοποθετούνται για θέσεις διαφημίσεων. Οι τιμές των προσφορών μπορούν να κυμανθούν από 0,05 έως το ανώτερο τέλος των 100€ ανά κλικ. Οι τιμές προσφοράς για τις λέξεις-κλειδιά για τις περισσότερες επιχειρήσεις κυμαίνονται από 0,20€ έως 5,00€ ανά κλικ. Αυτό θα καθοριστεί από την έρευνά μας και ποιοι τύποι αντιστοίχισης έχουν επιλεχθεί. Η τιμή προσφοράς εξαρτάται από το πόσο ψηλά θέλετε να βλέπετε τις διαφημίσεις σας και πόσος ανταγωνισμός υπάρχει για τις φράσεις-κλειδιά που έχουν επιλεχθεί."
            }
        }, {
            "@type": "Question",
            "name": "Μπορώ να εντοπίσω τηλεφωνήματα και emails που προήλθαν λόγω του Google Ads (πρώην AdWords);",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Ναι, χρησιμοποιώντας τους αριθμούς προώθησης Google, τα κουμπιά κλήσεων για κινητά και την παρακολούθηση συμπλήρωσης της φόρμας. Έτσι θα μπορείτε να καταλάβετε τι λειτουργεί και τι όχι."
            }
        }, {
            "@type": "Question",
            "name": "Τι είναι καλύτερο; Το κοινό στόχος να επισκέπτεται μία γενική σελίδα ή μία πολύ συγκεκριμένη υποσελίδα ;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Πρέπει να επιλεχθεί η πιο σχετική με τον όρο αναζήτησης, σελίδα. Εάν ο όρος απαιτεί εξήγηση και μια ειδική σελίδα, τότε μπορεί να δικαιολογηθεί μια landing page. Αυτό θα συνέβαινε στην περίπτωση ενός νέου προϊόντος, μιας νέας λέξης ή μιας μοναδικής υπηρεσίας. Αν πρόκειται για έναν γενικό όρο που περιγράφει την επιχείρηση ως σύνολο, τότε μπορεί να είναι πιο κατάλληλη η αρχική σελίδα."
            }
        }, {
            "@type": "Question",
            "name": "Tι διαφημιστικό budget πρέπει να διαθέσω;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Ο προϋπολογισμός σας πρέπει να βασίζεται στους επιχειρηματικούς στόχους σας και στις προωθητικές ενέργειες των ανταγωνιστών σας. Εάν ξέρετε τον αριθμό των νέων πελατών που πρέπει να έχετε για να αυξήσετε ή να διατηρήσετε τα έσοδα σε σύγκριση με το ποσοστό μετατροπής σας, τότε υπολογίστε πόσα κλικ χρειάζεστε ανά ημέρα για να επιτύχετε αυτόν τον στόχο. Ο προϋπολογισμός σας θα πρέπει να το επιτρέπει αυτό, συν ένα μικρό περιθώριο ασφαλείας.Ο σημαντικότερος παράγοντας για τον καθορισμό του προϋπολογισμού σας είναι η αποτελεσματικότητα έναντι της τιμής. Αν εξοικονομείτε πολλά, περιορίζοντας τον προϋπολογισμό σας, τότε μπορεί να μην έχετε τα επίπεδα επισκεψιμότητας που χρειάζεστε. Από την άλλη πλευρά, αν ξοδεύετε περισσότερα από όσα μπορείτε να αντέξετε οικονομικά, η επιτυχία σας δεν θα είναι βιώσιμη."
            }
        }, {
            "@type": "Question",
            "name": "Γιατί η χρέωση των Google Ads (πρώην AdWords) ήταν μεγαλύτερη από το budget που είχα καθορίσει;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Ο λογαριασμός σας σπάνια θα είναι μεγαλύτερος από τον προϋπολογισμό σας μηνιαίως. Ωστόσο, εάν έχετε ένα υπόλοιπο από τον τελευταίο μήνα, μπορεί να προστεθεί στον επόμενο λογαριασμό."
            }
        }, {
            "@type": "Question",
            "name": "Μπορώ να κάνω διαφήμιση για δύο παρόμοια websites, από διαφορετικούς λογαριασμούς αλλά στοχεύοντας ίδιες λέξεις κλειδιά;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Όχι. Αυτό αντίκειται στην πολιτική των Google Ads (πρώην AdWords). Ακόμη και όταν πρόκειται για Google Ads (πρώην AdWords), η Google θέλει να προσφέρει στους χρήστες μια καλή εμπειρία - αυτό σημαίνει μια γνήσια ποικιλία προτάσεων και διαφημίσεων."
            }
        }, {
            "@type": "Question",
            "name": "Γιατί δεν μου εμφανίζονται οι διαφημίσεις μου στις δικές μου αναζητήσεις;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": `Για πολλούς λόγους :
                    -   Ο ημερήσιος προϋπολογισμός σας έχει δαπανηθεί.
                    -   Η προσφορά σας είναι πολύ χαμηλή για να εμφανιστεί η διαφήμιση στην πρώτη σελίδα.
                    -   Η πιστωτική / χρεωστική σας κάρτα απορρίφθηκε.
                    -	Η διαφήμιση απορρίφθηκε.
                    -	Δεν βρίσκεστε στην τοποθεσία στην οποία στοχεύετε.
                    -	Οι διαφημίσεις έχουν ρυθμιστεί να προβάλλονται σε συγκεκριμένες ώρες.`
            }
        }, {
            "@type": "Question",
            "name": "Πόσο συχνά με τιμολογεί η google;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Κάθε τριάντα ημέρες ή όταν φτάσουμε το όριο του budget"
            }
        }, {
            "@type": "Question",
            "name": "Οι διαφημίσεις μου στη google εμφανίζονται σωστά στα κινητά;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Ναι, μπορείτε να προβάλλετε τις διαφημίσεις σας σε κινητές συσκευές με πλήρη προγράμματα περιήγησης (smartphones και tablet υψηλής τεχνολογίας). Μπορείτε να προβάλλετε διαφημίσεις κειμένου, εικόνας, εφαρμογών και διαφημίσεων HTML5 σε κινητές συσκευές."
            }
        }, {
            "@type": "Question",
            "name": "Μπορούν οι διαφημίσεις μου να παίζονται συγκεκριμένες ημέρες και ώρες;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Ναι, είναι σχετικά απλό να ορίσετε συγκεκριμένες ώρες και ημέρες που θέλετε να εμφανίζεται η διαφήμισή σας. Με τη στρατηγική επιλογή των χρόνων κατά τις οποίες είναι πιθανότερο να αναζητηθεί το προϊόν και η υπηρεσία σας, μπορείτε να αξιοποιήσετε στο έπακρο τις δαπάνες σας στα Google Ads (πρώην AdWords). Οι ακριβείς ώρες και ημέρες θα εξαρτηθούν από την αγορά, τη θέση και την τοποθεσία σας."
            }
        }, {
            "@type": "Question",
            "name": "Πόσο συγκεκριμένη περιοχή μπορώ να στοχεύσω για τις διαφημίσεις μου;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Μπορείτε να καθορίσετε μια περιοχή τόσο μικρή όσο μια ακτίνα 1χλμ γύρω από μια συντεταγμένη GPS - για παράδειγμα, τη θέση του καταστήματός σας ή του γραφείου σας. Πολλές επιχειρήσεις στοχεύουν σε ένα συγκεκριμένο προάστιο ή ομάδα προαστίων. Μπορείτε να στοχεύσετε ολόκληρη τη χώρα (ή πολλές χώρες), αν θέλετε. Είναι όλα σχετικά με το να γνωρίζετε πού είναι το κοινό-στόχος σας."
            }
        }, {
            "@type": "Question",
            "name": "Η Google στέλνει τιμολόγιο για τις χρεώσεις;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Φυσικά. Δηλώστε τα φορολογικά στοιχεία της επιχείρησής σας και θα λαμβάνετε τιμολόγιο που μπορείτε να καταχωρείτε στα έξοδά σας, ως διαφημιστική δαπάνη."
            }
        }, {
            "@type": "Question",
            "name": "Υπάρχουν προϊόντα που δεν μπορούν να διαφημιστούν;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Ναι υπάρχει μία ολόκληρη λίστα από προϊόντα και υπηρεσίες που δεν μπορούν να διαφημιστούν, βάσει πολιτικής της Google <a href=\"https://support.google.com/adspolicy/answer/6008942?hl=el\">https://support.google.com/adspolicy/answer/6008942?hl=el</a>"
            }
        }]
    },
    webDevelopment: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [{
            "@type": "Question",
            "name": "Τί είναι το CMS - Content Management System;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": `Ένα CMS (Content Management System) ή αλλιώς Σύστημα Διαχείρισης Περιεχομένου είναι μια εφαρμογή για την διαχείριση του περιεχομένου μιας ιστοσελίδας, που επιτρέπει σε χρήστες να δημοσιεύουν περιεχόμενο, χωρίς να έχουν ιδιαίτερες τεχνικές γνώσεις. Έτσι δίνεται η δυνατότητα στους ιδιοκτήτες των επιχειρήσεων να προβαίνουν άμεσα στις απαραίτητες αλλαγές στο website τους και να ενημερώνουν σχετικά με τις προσφορές τους, το αγοραστικό κοινό τους. Ένα από τα πιο γνωστά CMS είναι το WordPress.
                        Για περισσότερες πληροφορίες ακολουθήστε τον παρακάτω σύνδεσμο. Link: <a href=\"https://think-plus.gr/wordpress-website/\">https://think-plus.gr/wordpress-website/</a>.`
            }
        }, {
            "@type": "Question",
            "name": "Τί είναι το WordPress;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": `Με τον όρο WordPress, αναφερόμαστε σε ένα σύστημα διαχείρισης περιεχομένου (CMS Content Management System), που μπορεί να χρησιμοποιηθεί για τη κατασκευή οποιασδήποτε ιστοσελίδας. Η αρχική του χρήση προοριζόταν για την υλοποίηση blogspots. Παρόλα αυτά με τη πάροδο των χρόνων, εξελίχθηκε στο πλέον σύγχρονο, ασφαλές και δημοφιλές πρόγραμμα κατασκευής ιστοσελίδων, που χρησιμοποιείται σε παγκόσμιο επίπεδο. Είναι σημαντικό να αναφερθεί, ότι πρόκειται για λογισμικό ανοιχτού κώδικα (open source), εξαιρετικά φιλικού τόσο με τις μηχανές αναζήτησης, όσο και με τα κοινωνικά δίκτυα. Τέλος, γεγονός που αποδεικνύει την σημασία του είναι, ότι το WordPress αποτελεί τη βάση για το 31% των websites παγκοσμίως.
                    Η Think Plus επενδύει δυναμικά στο WordPress και διαθέτει μεγάλη εμπειρία στην κατασκευή ιστοσελίδων με βάση τη συγκεκριμένη πλατφόρμα. Η δημιουργία 1000 και πλέον websites στα τελευταία δέκα έτη, μας δίνει την δυνατότητα να μπορούμε να σας καθοδηγήσουμε σωστά, για το πως θα αποκτήσετε μία ιστοσελίδα που θα αναδείξει την επιχείρησή σας και θα αποτελεί ταυτόχρονα και ένα εξαιρετικό εργαλείο marketing. Το μόνο που χρειάζεται να κάνετε είναι να μας εμπιστευτείτε.
                    Για περισσότερες πληροφορίες ακολουθήστε τον παρακάτω σύνδεσμο. Link: <a href=\"https://think-plus.gr/wordpress-website/\">https://think-plus.gr/wordpress-website/</a>.`
            }
        }, {
            "@type": "Question",
            "name": "Τί είναι το Shopify;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": `Το Shopify είναι η καλύτερη SaaS πλατφόρμα, σε παγκόσμιο επίπεδο, που υποστηρίζει όλες τις μορφές του ηλεκτρονικού εμπορίου/e-commerce. Προσφέρει ένα πλήθος δυνατοτήτων που μπορούν να ικανοποιήσουν τις απαιτήσεις, διαφόρων τύπων επιχειρήσεων, είτε μικρών είτε μεσαίων. Το Shopify διαθέτει όλα εκείνα τα εργαλεία που χρειάζεται μια επιχείρηση για να δημιουργήσει το δικό της ηλεκτρονικό κατάστημα και να ξεκινήσει να πουλάει άμεσα, ότι επιθυμεί τόσο εντός όσο και εκτός Ελλάδας.
                Για περισσότερες πληροφορίες ακολουθήστε τον παρακάτω σύνδεσμο. Link: <a href=\"https://think-plus.gr/kataskeyi-eshop-me-shopify/\">https://think-plus.gr/kataskeyi-eshop-me-shopify/</a>.`
            }
        }, {
            "@type": "Question",
            "name": "Τί εννοούμε με τον όρο SSGs (Static Site Generators);",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Τα SSGs ( Static Site Generators) είναι μια υβριδική προσέγγιση, που αφορά στο web development και επιτρέπει την δημιουργία ταχύτατων websites. Μάλιστα η Google, προτείνει αυτή την υβριδική προσέγγιση, καθώς απαιτείται λιγότερος χρόνος για την φόρτωση και την απεικόνιση μιας σελίδας. Αυτό σημαίνει καλύτερη κατάταξη στα οργανικά αποτελέσματα των μηχανών αναζήτησης. Ένα από τα πιο γνωστά Static Site Generators είναι το Gatsby."
            }
        }, {
            "@type": "Question",
            "name": "Τι είναι το PageSpeed;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Το PageSpeed είναι ένας από τους πιο σημαντικούς δείκτες που αναφέρεται στην κατασκευή και την κερδοφορία, ενός website. Με το PageSpeed μετράμε τον χρόνο που χρειάζεται για να φορτώσει μια σελίδα. Όσο μεγαλύτερος ο χρόνος φόρτωσης μιας σελίδας τόσο μεγαλύτερο θα είναι το bounce rate. Αυτό ταυτόχρονα σημαίνει λιγοστές έως μηδενικές πωλήσεις για το eshop σας."
            }
        }, {
            "@type": "Question",
            "name": "Τί είναι το UX (User Experience)",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Το UX, δηλαδή το User Experience αναφέρεται στη συνολική εμπειρία που προσφέρει ένα ψηφιακό οικοσύστημα στο χρήστη. Αυτό το οικοσύστημα μπορεί να είναι ένα website ή ένα application  κ.τ.λ. Όσο καλύτερη είναι η εμπειρία του χρήστη,  μετά από την επαφή του με την ιστοσελίδα μιας εταιρείας, τόσο μεγαλύτερη επιτυχία θα έχει η εταιρεία στο ηλεκτρονικό επιχειρείν και ακόμα περισσότερη κερδοφορία στο ηλεκτρονικό εμπόριο."
            }
        }, {
            "@type": "Question",
            "name": "Τί είναι το SEO (Search Engine Optimization);",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "To SEO (Search Engine Optimization), αφορά στην βελτιστοποίηση ενός website με σκοπό την καλύτερη κατάταξη στα οργανικά αποτελέσματα των μηχανών αναζήτησης. Το SEO, μακροπρόθεσμα μπορεί να μειώσει το κόστος απόκτησης νέων πελατών και να αυξήσει την κερδοφορία ενός website, ενός eshop ή ενός application."
            }
        }, {
            "@type": "Question",
            "name": "Τί είναι το Google Analytics;",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Το Google Analytics είναι μια δωρεάν υπηρεσία που επιτρέπει στους ιδιοκτήτες websites να αναλύουν την κίνηση και την κερδοφορία του site τους. Το Google Analytics προσφέρει επίσης ενημερώσεις και χρήσιμες συμβουλές για κάθε website."
            }
        }]
    }
}